import { Endpoints } from '@/core/models/endpoints.interface';

export interface JobBoardEndpoints extends Pick<Endpoints, 'GET_ALL' | 'GET_BY_ID' | 'POST' | 'PUT' | 'DELETE'> {
   POST_FILE: (jobBoardId: number) => string;
}

export const JOB_BOARD_ENDPOINTS: JobBoardEndpoints = {
   GET_ALL: () => '/job-boards',
   GET_BY_ID: (id: string) => `/job-boards/${id}`,
   POST: () => '/job-boards',
   PUT: (id: string) => `/job-boards/${id}`,
   DELETE: (id: number) => `/job-boards/${id}`,
   POST_FILE: (jobBoardId: number) => `/job-boards/${jobBoardId}/files`,
};
